import {createTextVariant} from './Text.js'

export default createTextVariant('h3', 'H3')
